import { render } from "./WelcomeTab.vue?vue&type=template&id=0be733d2"
import script from "./WelcomeTab.vue?vue&type=script&lang=js"
export * from "./WelcomeTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__